import { Box, Typography } from '@mui/material';

interface SensorStatusDisplayProps {
  funnel?: string;
  pellets?: string;
  up?: string;
}

export const SensorStatusDisplay = ({ funnel, pellets, up }: SensorStatusDisplayProps) => {
  if (funnel === undefined && pellets === undefined && up === undefined) return null;

  return (
    <Box
      sx={{
        p: 2,
        backgroundColor: (theme) =>
          theme.palette.mode === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
        borderRadius: 1,
        border: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <Typography
        variant="caption"
        sx={{ fontWeight: 600, color: 'text.secondary', mb: 1, display: 'block' }}
      >
        Sensor Status
      </Typography>
      <Box sx={{ display: 'inline-flex', gap: 3 }}>
        {funnel !== undefined && (
          <Typography variant="body2">
            <strong>Funnel:</strong>{' '}
            <Box
              component="span"
              sx={{
                color: funnel === 'true' ? 'success.main' : 'error.main',
                fontWeight: 600,
              }}
            >
              {funnel === 'true' ? 'Active' : 'Inactive'}
            </Box>
          </Typography>
        )}
        {up !== undefined && (
          <Typography variant="body2">
            <strong>Pellets Up:</strong>{' '}
            <Box
              component="span"
              sx={{
                color: up === 'true' ? 'success.main' : 'error.main',
                fontWeight: 600,
              }}
            >
              {up === 'true' ? 'Active' : 'Inactive'}
            </Box>
          </Typography>
        )}
        {pellets !== undefined && (
          <Typography variant="body2">
            <strong>Pellets Down:</strong>{' '}
            <Box
              component="span"
              sx={{
                color: pellets === 'true' ? 'success.main' : 'error.main',
                fontWeight: 600,
              }}
            >
              {pellets === 'true' ? 'Active' : 'Inactive'}
            </Box>
          </Typography>
        )}
      </Box>
    </Box>
  );
};
